import { call } from '@advanza/api'
import { FileDropZone, Radio } from '@advanza/input'
import { Button, Divider } from '@advanza/ui'
import { useState } from 'react'
import LinearLoader from '../LinearLoader'

interface Props {
    serviceId: number
    buttonText: string
    text: string
    action: string
}

const ServiceFileDropAction = ({ serviceId, buttonText, text, action }: Props) => {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(false)
    const [result, setResult] = useState('')

    const [providerOption, setProviderOption] = useState(null as string | number | null)
    const [subscriptionOption, setSubscriptionOption] = useState(null as string | number | null)

    const schedule = async (files: File[], task: string) => {
        const endpoint = 'office/services/' + task + '/' + serviceId
        setLoading(true)
        call(endpoint, {
            payload: {
                file: files[0],
                options: JSON.stringify({
                    provider_option: providerOption,
                    subscription_option: subscriptionOption,
                }),
            },
        }).then(
            (response) => {
                setResult(JSON.stringify(response))
                setError(false)
                setLoading(false)
            },
            (response) => {
                setResult(JSON.stringify(response))
                setError(true)
                setLoading(false)
            },
        )
    }

    const importOptions = (
        <>
            <Divider m />
            Provider status:{' '}
            <Radio
                options={[
                    { value: 'ghost', name: 'GHOST' },
                    { value: 'new_import', name: 'NEW_IMPORT' },
                ]}
                onChange={(e) => {
                    setProviderOption(e.target.value)
                }}
                value={providerOption}
            />
            <Divider m />
            Subscription status:{' '}
            <Radio
                options={[
                    { value: 'active', name: 'ACTIVE' },
                    { value: 'paused', name: 'PAUSED' },
                ]}
                onChange={(e) => {
                    setSubscriptionOption(e.target.value)
                }}
                value={subscriptionOption}
            />
            <Divider m />
        </>
    )

    return (
        <div>
            <div>{text}</div>
            {action === 'schedule-import' && importOptions}
            <Divider m />
            <FileDropZone onFilesAccepted={(files: File[]) => schedule(files, action)}>
                <Button>{buttonText}</Button>
            </FileDropZone>
            <Divider m />
            <div style={{ color: error ? 'red' : 'inherit' }}>
                {result} {error}
            </div>
            <Divider m />
            {loading && <LinearLoader absolute />}
        </div>
    )
}

export default ServiceFileDropAction
